export enum HttpStatus {
    NetworkError = 0,
    BadRequest = 400,
    NotFound = 404,
    ServerError = 500,
    Unauthorized = 401,
  }